<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      <p>{{popupHeader}}</p>
      <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content class="">
  <div class="row sche-doc-head eip-mt-20 eip-ml-xs-10 eip-mr-xs-10" *ngIf="IsSupersede==false && IsEdit==false">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 eip-pl-10">
          <mat-label class="font-weight-bold eip-mr-10">Numbering Format : </mat-label>
          <mat-button-toggle-group #group="matButtonToggleGroup" class="sche-semiauto" aria-label="Numbering Format" [value]='numFormat' (change)="onValChange($event.value)">
              <mat-button-toggle value="Semi">Semi</mat-button-toggle>
              <mat-button-toggle value="Manual" *ngIf="canManualNo">Manual</mat-button-toggle>
              <mat-button-toggle value="Auto">Auto</mat-button-toggle>
          </mat-button-toggle-group>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 eip-pr-10">
          <div class="d-flex justify-content-end align-items-center">
              <div>
                  <p class="font-weight-bold eip-mr-10">No of Docs to Upload :</p>
              </div>
              <div><input matInput type="number" class="doc-input" Min="1" Max="5" name="rateInput" [formControl]="rateControl" (change)="onInputValChange()" matInput placeholder="1">
                  <mat-error *ngIf="rateControl.value>5">
                      Maximum value is 5
                  </mat-error>
              </div>
              <div> <i class="fa fa-arrow-right fs-24 eip-link sche-arrow" (click)="addDocument()" aria-hidden="true" id="btnCopy"></i>
              </div>
          </div>
      </div>
  </div>
  <ng-container *ngFor="let doc of noOfDocsArr;let i = index">
      <app-document-inputs [formControl]="parentForm" (ngsubmit)="saveAllDocument()" [docIndex]="i+1" [numFormat]='numFormat' [readonly]="readonly" [docNosOf]="docNosOf" (getDocumentSerialNo)="getDocumentSerialNo($event)" [sourceDocComponent]="sourceDocComponent" [editDocument]="document" [autoSerialNoMap]="autoSerialNoMap" [isEdit]="IsEdit" [isSupersede]="IsSupersede">
      </app-document-inputs>
  </ng-container>
</div>
<div mat-dialog-actions>
  <div class="row reset-row d-flex justify-content-end flex-grow-1">
      <div class="d-flex eip-p-0">
          <button class="btn btn-primary" id="btnsaveAllDocument" (click)="saveAllDocument()"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;Save</button>
          <button class="btn btn-secondary" id="btnReset" (click)="reSetAll()" *ngIf="IsEdit==false"><i class="fa fa-reset" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Reset</button>
          <button class="btn btn-secondary" id="btnCancel" (click)="closeDialog()"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
      </div>
  </div>
</div>